export default {
  CONTEXTS: {
    ASSETS: 'ASSETS',
    SEARCH: 'SEARCH',
  },

  ORDER_BY_FIELDS: {
    CREATED_TIME: 'createdTime',
    FOLDER: 'folder',
    MODIFIED_BY_ME_TIME: 'modifiedByMeTime',
    MODIFIED_TIME: 'modifiedTime',
    NAME: 'name',
    NAME_NATURAL: 'name_natural',
    QUOTA_BYTES_USED: 'quotaBytesUsed',
    RECENCY: 'recency',
    SHARED_WITH_ME_TIME: 'sharedWithMeTime',
    STARRED: 'starred',
    VIEWED_BY_ME_TIME: 'viewedByMeTime',
  },

  SORT_DIR: {
    DESCENDING: 'desc',
    ASCENDING: 'asc',
  },
  FILE_FIELDS: [
    'id',
    'mimeType',
    'name',
    'thumbnailLink',
    'createdTime',
    'modifiedTime',
    'fileExtension',
    'size',
    'sharingUser(displayName,me)',
    'imageMediaMetadata(height,width,rotation)',
    'videoMediaMetadata(height,width,durationMillis)',
    'webViewLink',
    'webContentLink',
    'parents',
    'shared',
    'resourceKey',
    'capabilities(canDownload)',
  ],
};

export const GOOGLE_DRIVE_RESOURCE_HEADER_KEY = 'X-Goog-Drive-Resource-Keys';

export const MIME_TYPE = {
  FOLDER: 'folder',
  FILE: 'file',
};

export const PREDEFINED_KINDS = {
  MY_DRIVE: 'myDrive',
  SHARED_DRIVE: 'sharedDrive',
  DRIVE: 'drive',
  SHARED_WITH_ME: 'sharedWithMe',
  STARRED: 'starred',
  RECENT: 'recency',
  SEARCH: 'search',
};

export const KIND = {
  ...MIME_TYPE,
  ...PREDEFINED_KINDS,
};

export const MODE = {
  TREE: 'tree',
  SEARCH: 'search',
};

export const PREDEFINED_TREE_NODES = {
  MY_DRIVE: 'root',
  SHARED_DRIVE: 'sharedDrive',
  SHARED_WITH_ME: 'sharedWithMe',
  STARRED: 'starred',
  RECENT: 'recent',
};

export const SEARCH_RESULTS_ID = 'searchResults';

export const STATUSES = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export const FILTERS = {
  STARRED: 'starred',
  SHARED_WITH_ME: 'sharedWithMe',
  RECENT: 'recency',
};

export const ORDER_BY = {
  NAME: 'name',
  MODIFIED_TIME: 'modifiedTime',
  MODIFIED_BY_ME_TIME: 'modifiedByMeTime',
  VIEWED_BY_ME_TIME: 'viewedByMeTime',
};

export const SORT = {
  ASC: 'asc',
  DESC: 'desc',
};

export const CORPORA = {
  USER: 'user',
  ALL_DRIVES: 'allDrives',
  DRIVE: 'drive',
};

export const EXPORT_MIME_MAP = {
  'Google Presentation': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'Google Spreadsheet': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'Google Document': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'Google Drawing': 'image/png',
};

export const EXPORT_TYPE_EXT_MAP = {
  'Google Presentation': '.pptx',
  'Google Spreadsheet': '.xlsx',
  'Google Document': '.docx',
  'Google Drawing': '.png',
};
